<template>
    <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="submit" id="settings_form">
                <p class="pb-3">
                    {{ $t('notification.label.choose_notification') }}
                </p>
                <kt-form-section>
                    <kt-row class="mb-3">
                        <kt-col lg="12" md="12" xs="12">
                            <div class="custom-control custom-checkbox" id="send_change_password-div">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="send_change_password"
                                    name="send_change_password"
                                    v-model="form_data.send_change_password"
                                >
                                <label class="custom-control-label" for="send_change_password">
                                    {{ $t('notification.label.send_change_password') }}
                                </label>
                            </div>
                        </kt-col>
                    </kt-row>
                    <kt-row class="mb-3">
                        <kt-col lg="12" md="12" xs="12">
                            <div class="custom-control custom-checkbox" id="send_ticket_reply-div">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="send_ticket_reply"
                                    name="send_ticket_reply"
                                    v-model="form_data.send_ticket_reply"
                                >
                                <label class="custom-control-label" for="send_ticket_reply">
                                    {{ $t('notification.label.send_ticket_reply') }}
                                </label>
                            </div>
                        </kt-col>
                    </kt-row>
                    <kt-row class="mb-3">
                        <kt-col lg="12" md="12" xs="12">
                            <div class="custom-control custom-checkbox" id="send_terminal_change_status-div">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="send_terminal_change_status"
                                    name="send_terminal_change_status"
                                    v-model="form_data.send_terminal_change_status"
                                >
                                <label class="custom-control-label" for="send_terminal_change_status">
                                    {{ $t('notification.label.send_terminal_change_status') }}
                                </label>
                            </div>
                        </kt-col>
                    </kt-row>
                    <kt-row class="mb-3">
                        <kt-col lg="12" md="12" xs="12">
                            <div class="custom-control custom-checkbox" id="send_successful_transaction-div">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="send_successful_transaction"
                                    name="send_successful_transaction"
                                    v-model="form_data.send_successful_transaction"
                                >
                                <label class="custom-control-label" for="send_successful_transaction">
                                    {{ $t('notification.label.send_successful_transaction') }}
                                </label>
                            </div>
                        </kt-col>
                    </kt-row>
                    <kt-row class="mb-3">
                        <kt-col lg="12" md="12" xs="12">
                            <div class="custom-control custom-checkbox" id="send_settlement-div">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="send_settlement"
                                    name="send_settlement"
                                    v-model="form_data.send_settlement"
                                >
                                <label class="custom-control-label" for="send_settlement">
                                    {{ $t('notification.label.send_checkout') }}
                                </label>
                            </div>
                        </kt-col>
                    </kt-row>
                </kt-form-section>
                <kt-form-action class="mt-4">
                    <kt-button
                        class="m-2"
                        size="md"
                        variant="success"
                        type="submit"
                        v-bind:wide="true"
                        id="submit_btn"
                    >
                        {{ $t('notification.btn.submit') }}
                    </kt-button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
export default {
    name: "notificationForm",
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },

}
</script>

<style scoped>

</style>